import { callApi } from '../../../../../apiCaller';
import { toastError } from '../../../../../utils';

export const API_SUBSCRIBER_ACTIVE_SEATS = 'user/product/active-seats/:userId';

export const SET_ACTIVE_SEAT_LIST_BY_USER = 'setActiveSeatListByUser';
export const ADD_ACTIVE_SEAT_BY_USER = 'addActiveSeatByUser';
export const DELETE_ACTIVE_SEAT_BY_USER = 'deleteActiveSeatByUser';
export const SET_SEAT_BY_TOKEN = 'setSeatByToken';
export const SET_SEAT_ADDRESS = 'setSeatAddress';

export const setActiveSeatListByUser = (listActiveSeatByUser) => {
     return {
          type: SET_ACTIVE_SEAT_LIST_BY_USER,
          payload: listActiveSeatByUser,
     };
};

export const deleteActiveSeatByUser = (activeSeatId) => {
     return {
          type: DELETE_ACTIVE_SEAT_BY_USER,
          payload: activeSeatId,
     };
};

export const setSeatByToken = (seatByToken) => {
     return {
          type: SET_SEAT_BY_TOKEN,
          payload: seatByToken,
     };
};

export const setSeatAddress = (seatAddress) => {
     return {
          type: SET_SEAT_ADDRESS,
          payload: seatAddress,
     };
};

export const fetchActiveSeatListRequest = (userId) => (dispatch) => {
     callApi(API_SUBSCRIBER_ACTIVE_SEATS.replace(':userId', userId), 'GET').then((response) => {
          if (response.status === 200) {
               dispatch(setActiveSeatListByUser(response.data));
          } else {
               toastError(response);
          }
     });
};
